import script from "./Automation.vue?vue&type=script&setup=true&lang=js"
export * from "./Automation.vue?vue&type=script&setup=true&lang=js"

import "./Automation.vue?vue&type=style&index=0&id=5d13e40c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d13e40c"]])

export default __exports__